/**
 * Canonical promotion-domain types.
 *
 * Consumers should import promotion-shaped types from here instead of
 * deep-importing from individual modules. Legacy paths (`src/services/bonuses/types`,
 * `promoCodes/services/promo-codes.interface`, etc.) remain as re-export
 * shims until consumers have migrated, then will be removed in Phase 9.
 */

export * from './enums';
export * from './boost.types';
export * from './voucher.types';
export * from './bonus.types';
export * from './promo-code.types';
export * from './promotion.types';
export * from './carousel.types';
export * from './entry-state.types';
export * from './component.types';
